import {
  CorrespondenceEntityName,
  useCreateCorrespondenceThreadMutation,
  useMarkCorrespondencesAsReadMutation,
} from "toptaal-shared"
import { correspondenceQueryKeys } from "toptaal-shared"
import { getFilteredCorrespondence } from "toptaal-shared"
import {
  createFileRoute,
  useNavigate,
  useParams,
  useRouter,
  useSearch,
} from "@tanstack/react-router"
import {
  CorrespondenceEntityType,
  CorrespondenceOverview,
  CorrespondenceThread,
  useCorrespondenceRoute,
  createTableSearchSchema,
} from "toptaal-shared"
import { can } from "@/utils/can"
import { checkPermissions } from "@/utils/checkPermissions"
import { useCurrentUserSuspenseQuery } from "@/api/queries/useCurrentUserSuspenseQuery"
import { useProjectSuspenseQuery } from "@/api/queries/projects/useProjectSuspenseQuery"

export const Route = createFileRoute(
  "/beheer/contracten/$contractId/correspondentie/",
)({
  component: RouteComponent,
  validateSearch: createTableSearchSchema(),
  beforeLoad: async () => {
    return checkPermissions("read", "projectCorrespondence")
  },
})

function RouteComponent() {
  const { contractId } = useParams({
    from: "/beheer/contracten/$contractId/correspondentie/",
  })
  const searchParams = useSearch({
    from: "/beheer/contracten/$contractId/correspondentie/",
  })
  const navigate = useNavigate({
    from: "/beheer/contracten/$contractId/correspondentie/",
  })

  const router = useRouter()
  const { data: user } = useCurrentUserSuspenseQuery()
  const { data: project } = useProjectSuspenseQuery({
    projectId: Number(contractId),
  })

  const entityType: CorrespondenceEntityType = "Project"
  const entityId = Number(contractId)
  const entityName: CorrespondenceEntityName = project.name

  const correspondenceProps = useCorrespondenceRoute({
    entityType,
    entityId,
    queryKey: correspondenceQueryKeys.project(entityId, entityType),
    queryFn: (filters) =>
      getFilteredCorrespondence({ entityId, entityType, filters }),
    useCreateMutation: useCreateCorrespondenceThreadMutation,
    searchParams,
    navigate,
  })

  const markAsReadMutation = useMarkCorrespondencesAsReadMutation({
    queryKey: correspondenceQueryKeys.project(entityId, entityType),
  })

  const handleNavigateToThread = (thread: CorrespondenceThread) => {
    if (thread.unreadCount > 0) {
      markAsReadMutation.mutate([thread.id])
    }

    router.navigate({
      to: "/beheer/contracten/$contractId/correspondentie/$threadId",
      replace: true,
      params: {
        threadId: String(thread.id),
        contractId,
      },
    })
  }

  return (
    <CorrespondenceOverview
      {...correspondenceProps}
      handleNavigateToThread={handleNavigateToThread}
      contextType={entityType}
      entityName={entityName}
      canCreateCorrespondence={can("create", "projectCorrespondence")}
      correspondencePermission={{
        root: "mtt",
        roles: user.data.roles,
        baseUserId: user.data.baseUserId,
      }}
    />
  )
}
